export const reportingTableRowNameFormat = (groupName: string | boolean) => {
  if (typeof groupName === 'boolean') {
    return groupName ? 'Yes' : 'No';
  }
  switch (groupName) {
    case 'active': {
      return 'Active';
    }
    case 'deactivated': {
      return 'Deactivated';
    }
    case 'invitation_expired': {
      return 'Invitation expired';
    }
    case 'password_reset': {
      return 'Password reset';
    }
    case 'care_manager': {
      return 'Care manager';
    }
    case 'care_navigator': {
      return 'Care navigator';
    }
    case 'data_analyst': {
      return 'Data analyst';
    }
    case 'organization_admin': {
      return 'Organization admin';
    }
    case 'user_admin': {
      return 'User admin';
    }
    case 'partner_admin': {
      return 'Partner admin';
    }
    case 'pharmacist': {
      return 'Pharmacist';
    }
    case 'provider': {
      return 'Provider';
    }
    case 'quality_assurance': {
      return 'Quality assurance';
    }
    case 'reporter': {
      return 'Reporter';
    }
    case 'super_admin': {
      return 'Super admin';
    }
    case 'wellness_coordinator': {
      return 'Wellness coordinator';
    }
    case 'organization_supervisor': {
      return 'Organization supervisor';
    }
    case 'partner_supervisor': {
      return 'Partner supervisor';
    }
    case 'operations_coordinator': {
      return 'Operations coordinator';
    }
    case 'buildings_manager': {
      return 'Buildings manager';
    }
    case 'executive_reporter': {
      return 'Executive reporter';
    }
    default: {
      return groupName;
    }
  }
};
